import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import internet from '@devices/settings/device_settings/internet.js';
import safety from '@devices/settings/device_settings/safety.js';
import relay_pm_app_settings from '@devices/settings/device_settings/app_settings_pm_gen_1.js';
import share from '@devices/settings/device_settings/share.js';
import { createSceneCapabilities } from '@components/Flows/sceneCapabilities/index.js';

export default {
	name: 'shellyHDpro',
	friendly_name: 'HDPro',
	family: 'relay',
	isPM: true,
	modes: {
		relay: {
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer,
				schedule,
				actions,
				internet,
				safety,
				relay_pm_app_settings,
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			sceneCapabilities: createSceneCapabilities({
				template: 'dual_relay_pm_gen1',
			}),
		},
	},
};
